import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { required, email, url, requiredIf } from "vuelidate/lib/validators";
import citiesData from "@/assets/json_data/cities.json";
import countiesData from "@/assets/json_data/counties.json";
import $ from "jquery";

// set cities data
var citiesList = [];
var keys = Object.keys(citiesData);
keys.forEach(function (key) {
  citiesList.push(citiesData[key]);
});

// set counties data
var countiesList = [];
var keys = Object.keys(countiesData);
keys.forEach(function (key) {
  countiesList.push(countiesData[key]);
});

const file_size_validation = (value, vm) => {
  if (!value) {
    return true;
  }
  let file = value;
  return file.size < 1048576;
};
const image_type_validation = (value, vm) => {
  if (!value) {
    return true;
  }
  let file = value;
  if (
    file.type == "image/svg+xml" ||
    file.type == "image/jpeg" ||
    file.type == "image/gif" ||
    file.type == "image/png"
  ) {
    return true;
  } else {
    return false;
  }
};
  
  export default {
    components: {
    },
    data() {
      return {
        CompanyId: 0,
        Saving: false,
        submitted: false,
        Companies: false,
        isTrackingModule:false,
        Categories: {},
        type: "password",
        Counties: countiesList,
        Cities: citiesList,
        Subscriptions: {},
        FleetSubscriptions: {},
        CompanyLogoFilename: "",
        CompanyBannerFilename: "",
        UpdateCompany: {
          name: "",
          mileage_unit: "",
          currency_type: "",
          logo_image: "",
          website: "",
          email: "",
          colour_1: "",
          colour_2: "",
          Banner: "",
          contact_number: "",
          address: "",
          town: "",
          county: "",
          postcode: "",
          Facebook: "",
          Twitter: "",
          LinkedIn: "",
          YouTube: "",
          Instagram: "",
          banner_image: "",
          MOTPartner: "",
          TaxPartner: "",
          LicenseCheckPartner: "",
          InsurancePartner: "",
          CarSellPartner: "",
          AccidentReportPartner: "",
          GarageBookingPartner: "",

          TrackerCompany: "",
          TrackerUsername: "",
          TrackerPassword: "",
          TrackerApiUrl: "",

          csc_client_id:"",
          csc_client_secret:"",
          csc_url:""
          
        },
      };
    },
    validations: {
      UpdateCompany: {
        name: { required },
        mileage_unit: { required },
        currency_type: { required },
        logo_image: { file_size_validation, image_type_validation },
        website: {
          required,
          url,
        },
        email: { required, email },
        contact_number: { required },
        address: { required },
        /* town: { required },
        county: { required }, */
        postcode: { required },
        company_note: {},
        banner_image: {
          file_size_validation,
          image_type_validation,
        },
      },
    },
    mounted() {
      var FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );

      this.FleetSubscription = FleetSubscription;

      var FleetSubscriptionModules = JSON.parse(
        FleetSubscription.fleet_modules
      );
      var AccountRoles = JSON.parse(localStorage.getItem("permissions"));
      if (
        FleetSubscriptionModules["Hierarchy System"] &&
        AccountRoles.fleet_role_id != 1
      ) {
        this.$router.push("/");
      }
      
      document.title = pbx_SiteTitle + " - Update Company Details";
      var CompanyData = JSON.parse(localStorage.getItem("Company"));
      this.CompanyId = CompanyData.id;
      this.GetCategoriesList();
      this.getCompanyData();
      if(FleetSubscriptionModules['Vehicle Tracking']){
        this.isTrackingModule = true;
      }
    },

    methods: {
      showPassword: function () {
        if (this.type === "password") {
          this.type = "text";
        } else {
          this.type = "password";
        }
      },
      getCompanyData() {
        Axios.post(Endpoints.User.Company, {
          token: localStorage.getItem("token"),
          id: this.CompanyId,
        }).then((Response) => {
          if (typeof Response.data.company != "undefined") {
            
            this.UpdateCompany = Response.data.company;

            localStorage.setItem(
              "Company",
              JSON.stringify(Response.data.company)
            );

            // set social links
            var settingData = JSON.parse(Response.data.company.email_settings);
            this.UpdateCompany.Banner = settingData.Banner;
            this.UpdateCompany.Facebook = settingData.Social.Facebook;
            this.UpdateCompany.Twitter = settingData.Social.Twitter;
            this.UpdateCompany.Instagram = settingData.Social.Instagram;
            this.UpdateCompany.LinkedIn = settingData.Social.LinkedIn;
            this.UpdateCompany.YouTube = settingData.Social.YouTube;
            
            if (typeof settingData.CompanyPartner != "undefined") {
              this.UpdateCompany.MOTPartner =
                settingData.CompanyPartner.MOTPartner;
              this.UpdateCompany.TaxPartner =
                settingData.CompanyPartner.TaxPartner;
              this.UpdateCompany.LicenseCheckPartner =
                settingData.CompanyPartner.LicenseCheckPartner;
              this.UpdateCompany.InsurancePartner =
                settingData.CompanyPartner.InsurancePartner;
              if (
                typeof settingData.CompanyPartner.CarSellPartner != "undefined"
              ) {
                this.UpdateCompany.CarSellPartner =
                  settingData.CompanyPartner.CarSellPartner;
                this.UpdateCompany.AccidentReportPartner =
                  settingData.CompanyPartner.AccidentReportPartner;
                this.UpdateCompany.GarageBookingPartner =
                  settingData.CompanyPartner.GarageBookingPartner;
              }
            }
            
            this.UpdateCompany.contact_type =
              this.UpdateCompany.contacts.length > 0
                ? this.UpdateCompany.contacts.length
                : 1;
            //set contact data
            this.UpdateCompany.contacts.forEach((Contact) => {
              if (typeof Contact.contact_type != "undefined") {
                if (Contact.contact_type == 1) {
                  //set ceo contact data
                  this.UpdateCompany.forename = Contact.forename;
                  this.UpdateCompany.surname = Contact.surname;
                  this.UpdateCompany.ceo_email = Contact.email;
                  this.UpdateCompany.ceo_contact_number =
                    Contact.contact_number;
                } else if (Contact.contact_type == 2) {
                  //set champion contact data
                  this.UpdateCompany.champion_firstname = Contact.forename;
                  this.UpdateCompany.champion_lastname = Contact.surname;
                  this.UpdateCompany.champion_email = Contact.email;
                  this.UpdateCompany.champion_contact_number =
                    Contact.contact_number;
                }
              }
            });
           
          }
          this.Saving = false;
          // get old company logo
          this.CompanyLogoFilename = this.UpdateCompany.logo;
          if (this.UpdateCompany.logo != "") {
            this.GetCompanyLogo();
          }
          // get old banner
          this.CompanyBannerFilename = this.UpdateCompany.Banner;
          if (this.UpdateCompany.Banner != "") {
            this.GetCompanyBanner();
          }
        });
      },
      GetCompanyLogo() {
        Axios.post(Endpoints.Helper.File.Get, {
          token: localStorage.getItem("token"),
          file: this.CompanyLogoFilename,
          company_id: this.CompanyId,
        }).then((FileGetResponse) => {
          var FileData = FileGetResponse.data;
          if (FileData.success === true) {
            this.CompanyLogo = FileData.file;
            this.$refs.CompanyLogoPreview.src = FileData.file;
          }
        });
      },
      GetCompanyBanner() {
        Axios.post(Endpoints.Helper.File.Get, {
          token: localStorage.getItem("token"),
          file: this.CompanyBannerFilename,
          company_id: this.CompanyId,
        }).then((FileGetResponse) => {
          var FileData = FileGetResponse.data;
          if (FileData.success === true) {
            this.CompanyBanner = FileData.file;
            this.$refs.CompanyBannerPreview.src = FileData.file;
          }
        });
      },
      GetCategoriesList() {
        Axios.post(Endpoints.Assets.Category.List, {
          token: localStorage.getItem("token"),
        }).then((Response) => {
          this.Categories = Response.data.CategoryList;
        });
      },
      imageFileChanged(event) {
        var files = event.target.files || event.dataTransfer.files;
        if (!files.length) {
          return;
        }
        this.UpdateCompany.logo_image = files[0];
        var output = document.querySelector(".company__logo__preview");
        output.src = URL.createObjectURL(files[0]);
        output.onload = function () {
          URL.revokeObjectURL(output.src); // free memory
        };
      },
      bannerImageFileChanged(event) {
        var files = event.target.files || event.dataTransfer.files;
        if (!files.length) {
          return;
        }
        this.UpdateCompany.banner_image = files[0];
      },
      UpdateCompanyData() {
        var error = false;
        var errorStr = "";

        if($('#inseego_username').val() !=""){
          if($('#inseego_password').val() ==""){
              error = true;
              errorStr = 'Please enter Inseego API password';
          }
        }
        if($('#inseego_password').val() !=""){
          if($('#inseego_username').val() ==""){
              error = true;
              errorStr = 'Please enter Inseego API username';
          }
        }
        if(!error){
          this.submitted = true;
          this.$v.$touch();
          if (this.$v.$invalid) {
            return;
          }
  
          this.Saving = true;
          Axios.post(Endpoints.Company.Update, {
            token: localStorage.getItem("token"),
            ...this.UpdateCompany,
          }).then((Response) => {
            if (Response?.data?.success) {
              this.SaveCompanyLogo(Response.data.last_id);
            } else {
              this.Saving = false;
              this.$swal.fire({
                title: "Oops!",
                text: Response?.data?.message || "Something went wrong",
                icon: "error",
                confirmButtonText: "Close",
              });
            }
          });
        }else{
          this.$swal
          .fire("Following Error Found!", errorStr, "error")
          .then(() => {});
        }
      },
      SaveCompanyLogo(id) {
        var LogoFormData = new FormData();
        if (this.$refs.logoFile.files[0]) {
          LogoFormData.append("storage_type", "CC");
          LogoFormData.append("token", localStorage.getItem("token"));
          LogoFormData.append("file", this.$refs.logoFile.files[0]);
          LogoFormData.append("company_id", id);
          Axios.post(Endpoints.Helper.File.Upload, LogoFormData).then(
            (UploadResponse) => {
              var UploadData = UploadResponse.data;
              if (UploadData.success === true) {
                Axios.post(Endpoints.Company.LogoSet, {
                  token: localStorage.getItem("token"),
                  logo: UploadData.file,
                  id: id,
                }).then((SetResponse) => {
                  this.SaveBannerImage(id);
                });
              }
            }
          );
        } else {
          this.SaveBannerImage(id);
        }
      },
      SaveBannerImage(id) {
        var BannerFormData = new FormData();
        if (this.$refs.bannerFile.files[0]) {
          BannerFormData.append("storage_type", "CC");
          BannerFormData.append("token", localStorage.getItem("token"));
          BannerFormData.append("file", this.$refs.bannerFile.files[0]);
          BannerFormData.append("company_id", id);
          Axios.post(Endpoints.Helper.File.Upload, BannerFormData).then(
            (UploadResponse) => {
              var UploadData = UploadResponse.data;
              if (UploadData.success === true) {
                Axios.post(Endpoints.Company.BannerSet, {
                  token: localStorage.getItem("token"),
                  banner: UploadData.file,
                  id: id,
                }).then((SetResponse) => {
                  this.Saving = false;
                  this.getCompanyData()
                  this.$swal.fire("Company Updated Successfully", "", "success").then(
                    () => {
                        this.$router.go();
                    }
                  );
                });
              }
            }
          );
        } else {
          this.Saving = false;
          this.getCompanyData()
          this.$swal.fire("Company Updated Successfully", "", "success").then(() => {
            this.$router.go();
          });
        }
      },
    },
  };